<mat-drawer #drawer [mode]="'over'" position="end" style="width: 280px; margin-top: 60px">
  <ng-template #sidebarContainer></ng-template>
</mat-drawer>

<div class="menu-top-bar" fxLayout="row">
  <div fxFlex="18" fxLayout="column">
    <div class="menu-left" fxFlex="100">
      @if (!back.observers.length) {
        <mat-icon (click)="finishComponent()">close</mat-icon>
      }
      @if (back.observers.length) {
        <mat-icon (click)="back.emit()">arrow_back</mat-icon>
      }
    </div>
  </div>

  <div class="size2" fxLayout="row">
    <div class="brand-area" fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
      @if (title) {
        <nav class="plus2-tabs-mobile" mat-tab-nav-bar>
          <a [active]="true" class="break-spaces" mat-tab-link style="display: flex; flex-direction: column">
            {{ title | translate | titlecase }}
          </a>
        </nav>
      }
    </div>
  </div>

  @if (isLoggedIn) {
    <div fxFlex="20" fxLayout="column">
      <div class="logged-area money-title" fxFlex="100" fxFlexAlign="end">
        <button (click)="openMenuLogin()" class="vertical-button" mat-button>
          <div fxLayout="column" style="align-items: center">
            <mat-icon style="color: white"> account_circle</mat-icon>
            <span style="font-size: 11px; line-height: 20px !important; color: white">{{ getUserBalance() | currencycase }}</span>
          </div>
        </button>
      </div>
    </div>
  }
</div>
